import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
import LoadMoreProjects from '../components/LoadMoreProjects'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allProjects: [],
      projects: [],
      count: 8,
      offset: 0,
      totalAmountProjects: null,
      loadedAllProjects: false,
      isLoading: true,
      error: false,
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.increaseProjects = this.increaseProjects.bind(this)
  }

  componentDidMount() {
    this.fetchProjects()
  }

  fetchProjects() {
    this.setState({ isLoading: true })

    let promises = ProjectsAPI.all()

    Promise.all(promises)
    .then(results => {
      // flatten results into one array
      let data = [].concat.apply([], results)

      // sort data by date
      data.sort(this.latestFirst)

      // get the first few projects
      let limitedData = data.slice(0, this.state.count)

      window.setTimeout(() => {
        this.setState({
          allProjects: data,
          projects: limitedData,
          totalAmountProjects: data.length,
          loadedAllProjects: false,
          isLoading: false
        })
      }, 500)
    })
    .catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  latestFirst(a,b) {
    if (a.date > b.date)
      return -1;
    if (a.date < b.date)
      return 1;
    return 0;
  }

  increaseProjects() {
    this.setState({ isLoading: true })

    // get a few more projects
    let tail = this.state.offset + this.state.count
    let newProjects = this.state.allProjects.slice(this.state.offset, tail)

    window.setTimeout(() => {
      this.setState({
        projects: [...this.state.projects, ...newProjects],
        isLoading: false
      })
    }, 500)
  }

  handleLoadMore() {
    this.setState( (prevState) => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.increaseProjects )
  }

  render() {
    return (
      <div className="c-news-app">

        <Projects
          projects={this.state.projects}
          loading={this.state.isLoading}
          error={this.state.error}
          language={this.props.language}
        />

        <LoadMoreProjects
          onLoadMore={this.handleLoadMore}
          nrShowing={this.state.projects.length}
          nrAll={this.state.totalAmountProjects}
          loading={this.state.isLoading}
          language={this.props.language}
        />

      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/news/containers/App.js